function loadView( view ) {
    return () => import(`@/views/admin/events/${ view }.vue`);
}


const Index = loadView( 'Index' );
const EventView = loadView( 'View' );
import permission from "@/middlewares/permission";

const eventRoutes = [
    {
        path: 'events',
        name: 'api.testing.event.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'events/:id',
        name: 'api.testing.event.get',
        component: EventView,
        meta: {
            middleware: permission
        }
    },
];

export default eventRoutes;
